// extracted by mini-css-extract-plugin
module.exports = {"filter-section__search":"style_filter-section__search__16ByU"};